import React from 'react';
import { Stack } from '@chakra-ui/react';

const ResponsiveStack: React.FC = ({ children }) => (
  <Stack direction={{ base: 'column', md: 'row' }} py={2} justify="center">
    {children}
  </Stack>
);

export default ResponsiveStack;
